<template>
  <router-view />
</template>

<script>
export default {
  name: 'ReservationDBIndex'
}
</script>
